import styled from "styled-components";
import Modal from "react-modal";

const ViewMapModal = ({ closeModal, mapImage, isModalOpen }) => {
  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel="Modal confirmation"
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          width: "25rem",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 999,
        },
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <ModalContent>
          <CloseImage src={mapImage} onClick={closeModal} />
        </ModalContent>
      </div>
    </Modal>
  );
};

export default ViewMapModal;

const ModalContent = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  @media only screen and (max-width: 768px) {
    width: 80%;
    padding: 0 2.5rem;
  }
`;

const CloseImage = styled.img`
  width: 100%;
  height: 100%;
`;
